export const objectToArray = <T>(
  o: { [s: string]: T } | ArrayLike<T>,
): { key: string; value: any }[] => {
  return Object.entries(o).map(([key, value]) => ({
    key,
    value,
  }));
};
